module.exports = __webpack_public_path__ + "static/media/removebnt.3f7181e4.svg";